export function menu() {
  const menuTriggers = document.querySelectorAll('.js-menuTrigger');
  const hamburger = document.querySelector('.js-hamburger');
  const menu = document.querySelector('.js-menu');

  menuTriggers.forEach(item => {
    item.addEventListener("click", () => {
      menu.classList.toggle("is-opend");
      hamburger.classList.toggle("is-opend");
    })
  })
}
